import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTE_RULES } from '../routes/paths'

const useLoading = () => {
  const { pathname } = useLocation()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const isRouteRules = pathname.startsWith(ROUTE_RULES)

    if (isRouteRules) {
      const timer = setTimeout(() => {
        setLoading(false)
      }, 4000)

      return () => clearTimeout(timer)
    } else {
      setLoading(false)
    }
  }, [pathname])

  return loading
}

export default useLoading
